import { createContext, useState, useEffect } from "react"
import { Children, UserAuth } from "../Interfaces"

interface AuthContextProps {
  auth: UserAuth
  setAuth: (auth: UserAuth) => void
}

const AuthContext = createContext<AuthContextProps>({
  auth: { token: null, user: null },
  setAuth: () => { }
})

export const AuthProvider = ({ children }: Children) => {
  const [auth, setAuth] = useState<UserAuth>(() => {
    const token = localStorage.getItem("token")
    const user = localStorage.getItem("user")
    return {
      token: token,
      user: user ? JSON.parse(user) : null
    }
  })

  // Update localStorage when auth changes
  useEffect(() => {
    if (auth.token) {
      localStorage.setItem("token", auth.token)
      localStorage.setItem("user", JSON.stringify(auth.user))
    } else {
      localStorage.removeItem("token")
      localStorage.removeItem("user")
    }
  }, [auth])

  return <AuthContext.Provider value={{ auth, setAuth }}>{children}</AuthContext.Provider>
}

export default AuthContext
